import { render } from "./ColumnSpacing.vue?vue&type=template&id=8cbaf61c&scoped=true"
import script from "./ColumnSpacing.vue?vue&type=script&lang=js"
export * from "./ColumnSpacing.vue?vue&type=script&lang=js"

import "./ColumnSpacing.vue?vue&type=style&index=0&id=8cbaf61c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8cbaf61c"

export default script